/**
 * PDP — selección de variante (match contra window.__pdpVariants),
 * galería (progreso mobile + thumbnails desktop), acordeón, sticky ATC,
 * modal de guía de tallas.
 */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  // Formatea centavos igual que el filtro `money` de Liquid, usando el
  // formato real de la tienda (window.themeMoneyFormat, ver theme.liquid)
  // en vez de un símbolo/orden fijo a mano.
  function formatMoney(cents, format) {
    format = format || window.themeMoneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
  }

  var variants = window.__pdpVariants || [];

  // ── Variant selection ───────────────────────────────────────────────────
  var idInput = pdp.querySelector('[data-pdp-variant-id]');
  var optionButtons = pdp.querySelectorAll('[data-pdp-option]');
  var sizeSheet = pdp.querySelector('[data-pdp-size-sheet]');
  var sheetSizes = pdp.querySelectorAll('[data-pdp-sheet-size]');
  var atcBtn = pdp.querySelector('[data-pdp-atc]');
  var atcLabel = pdp.querySelector('[data-pdp-atc-label]');
  var atcPrice = pdp.querySelector('[data-pdp-atc-price]');
  var oosMsg = pdp.querySelector('[data-pdp-oos-msg]');
  var priceEl = pdp.querySelector('.pdp-info__price');

  // Los textos vienen de los archivos de idioma via atributos data- en el
  // markup: el filtro `t` solo existe en Liquid, aqui no hay forma de
  // leerlos. El segundo argumento es solo una red por si falta el atributo.
  function label(key, fallback) {
    return (atcBtn && atcBtn.dataset[key]) || fallback;
  }

  // Los botones del bloque de arriba y los del desplegable comparten el
  // mismo data-pdp-option, asi que ya son la misma seleccion. Marcar por
  // posicion+valor (en vez de por el boton pulsado) los deja iguales se
  // elija donde se elija, sin estado duplicado.
  function syncOption(position, value) {
    optionButtons.forEach(function (btn) {
      if (btn.dataset.pdpOption !== position) return;
      btn.classList.toggle('is-active', btn.dataset.pdpValue === value);
    });
  }

  // Un valor de opcion se puede elegir si existe ALGUNA variante disponible
  // con ese valor y el resto de options ya elegidos. Con .some y no .find
  // porque sin color elegido la primera coincidencia puede estar agotada
  // mientras otra del mismo talle sigue disponible.
  //
  // Se aplica a los DOS sitios donde salen botones de opcion (optionButtons,
  // el bloque principal de la pagina, cualquier opcion — y sheetSizes, solo
  // tallas, dentro del desplegable) — antes solo se calculaba para el
  // desplegable: una talla sin stock se veia exactamente igual que una
  // disponible en el bloque principal hasta que la pulsabas, y solo
  // entonces saltaba el aviso de agotado (updateForVariant). El CSS del
  // tachado para el bloque principal ya existia (.pdp-size-btn.is-disabled)
  // pero nunca se le aplicaba la clase.
  function refreshAvailability() {
    var chosen = selectedOptions();
    var applyAvailability = function (btn) {
      var pos = btn.dataset.pdpOption;
      var isAvailable = variants.some(function (v) {
        if (v['option' + pos] !== btn.dataset.pdpValue || !v.available) return false;
        return Object.keys(chosen).every(function (p) {
          return p === pos || v['option' + p] === chosen[p];
        });
      });
      btn.disabled = !isAvailable;
      btn.classList.toggle('is-disabled', !isAvailable);
    };
    optionButtons.forEach(applyAvailability);
    sheetSizes.forEach(applyAvailability);
  }

  function toggleSizeSheet(open) {
    if (!sizeSheet) return;
    if (open) refreshAvailability();
    sizeSheet.hidden = !open;
  }

  function selectedOptions() {
    var selections = {};
    optionButtons.forEach(function (btn) {
      if (btn.classList.contains('is-active')) {
        selections[btn.dataset.pdpOption] = btn.dataset.pdpValue;
      }
    });
    return selections;
  }

  function findMatchingVariant() {
    var selections = selectedOptions();
    return variants.find(function (v) {
      return Object.keys(selections).every(function (pos) {
        return v['option' + pos] === selections[pos];
      });
    });
  }

  function updateForVariant(variant) {
    if (!variant) {
      if (atcBtn) atcBtn.disabled = true;
      if (atcLabel) atcLabel.textContent = label('labelUnavailable', 'Unavailable');
      if (oosMsg) oosMsg.hidden = false;
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (oosMsg) oosMsg.hidden = variant.available;

    if (atcBtn) atcBtn.disabled = !variant.available;
    if (atcLabel) {
      atcLabel.textContent = variant.available
        ? label('labelAdd', 'Add to Cart')
        : label('labelSoldOut', 'Sold Out');
    }
    if (atcPrice) atcPrice.textContent = formatMoney(variant.price);

    if (priceEl) {
      var price = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.innerHTML =
          '<span class="price price--on-sale"><span class="price__compare-at"><s>' +
          formatMoney(variant.compare_at_price) +
          '</s></span><span class="price__current price__current--sale">' +
          price +
          '</span></span>';
      } else {
        priceEl.innerHTML = '<span class="price"><span class="price__current">' + price + '</span></span>';
      }
    }
  }

  // Estado inicial: que se vean tachadas las tallas/opciones sin stock
  // desde el primer render, sin esperar a que el usuario pulse nada.
  refreshAvailability();

  optionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      syncOption(btn.dataset.pdpOption, btn.dataset.pdpValue);
      updateForVariant(findMatchingVariant());
      refreshAvailability();
    });
  });

  // Elegir talla cierra el desplegable y añade al carrito de una: la talla
  // era el unico dato que faltaba, asi que pedir un segundo toque en "Add to
  // cart" solo mete friccion. Mismo camino que el quick-add de la product
  // card (fetch a /cart/add.js + evento cart:added, que cart-drawer.js ya
  // escucha para refrescar y abrir) — una sola forma de meter cosas en el
  // carrito en todo el tema.
  sheetSizes.forEach(function (btn) {
    btn.addEventListener('click', function () {
      toggleSizeSheet(false);

      // El handler de optionButtons se registra antes que este, asi que para
      // cuando llegamos aqui la variante ya esta resuelta.
      var variant = findMatchingVariant();
      if (!variant || !variant.available) return;

      btn.classList.add('is-adding');
      fetch(themeApiRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (item) {
          document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
        })
        .catch(function () {})
        .finally(function () {
          btn.classList.remove('is-adding');
        });
    });
  });

  if (sizeSheet) {
    var sheetClose = sizeSheet.querySelector('[data-pdp-size-sheet-close]');
    if (sheetClose) {
      sheetClose.addEventListener('click', function () {
        toggleSizeSheet(false);
      });
    }
  }

  // Ninguna talla llega pre-marcada como activa desde Liquid a propósito
  // (ver product.liquid) — el botón real empieza con la etiqueta "Select
  // Size" (nunca "Add to Cart" en gris/bloqueado) y, mientras no haya
  // talla elegida, en vez de enviar el form (que añadiría la talla por
  // defecto de current_variant sin que nadie la eligiera) despliega el
  // selector de tallas desde la propia barra.
  if (atcBtn && optionButtons.length) {
    // Solo renombrar si el boton puede pulsarse. Liquid lo renderiza con
    // disabled cuando la variante actual no esta disponible, y un boton
    // deshabilitado NO dispara click: poner "Select Size" ahi daba un boton
    // que parecia pulsable y no hacia nada nunca.
    if (atcLabel && !atcBtn.disabled) {
      atcLabel.textContent = label('labelSelect', 'Select Size');
    }

    atcBtn.addEventListener('click', function (e) {
      if (Object.keys(selectedOptions()).length > 0) return;
      e.preventDefault();
      if (sizeSheet) {
        toggleSizeSheet(sizeSheet.hidden);
        return;
      }
      var group = pdp.querySelector('.pdp-variant-group');
      if (group) group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  // La barra sticky (mobile) se "acopla" en su hueco reservado dentro de
  // .pdp-atc (justo encima de Shop Pay) en cuanto ese contenedor entra en
  // el viewport — a partir de ahí deja de flotar fija y pasa a formar
  // parte normal del scroll, ver product.liquid .pdp-atc__bar.is-docked.
  var atcBar = pdp.querySelector('[data-pdp-atc-bar]');
  var atcWrap = atcBar && atcBar.closest('.pdp-atc');

  if (atcBar && atcWrap && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        // OJO: aqui NO se puede cerrar el desplegable. En iOS, al tocar
        // cerca del borde inferior Safari contrae o despliega su barra de
        // direcciones, eso cambia el alto del viewport y dispara este
        // observador — cerrando el panel en el mismo gesto que lo abre. En
        // escritorio no pasa porque no hay barra que se mueva, y por eso el
        // fallo solo se veia en movil. El panel ya no lo necesita: tiene
        // fondo propio y se ve bien tanto flotando como acoplada.
        atcBar.classList.toggle('is-docked', entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(atcWrap);
  }

  // ── Desktop: .pdp__info sigue el scroll junto a la galeria ──────────────
  // Siempre position:fixed (igual que balenciaga.com), con ancho/right
  // calculados aqui desde la galeria — nunca position:absolute ni
  // matematicas relativas a .pdp: esas dos referencias (viewport vs.
  // containing block de .pdp) no dejaban de dar resultados ligeramente
  // distintos entre si. Un solo sistema de referencia (el viewport) todo
  // el rato; el "acople" al final de la galeria se hace con un
  // transform: translateY, no cambiando de position.
  var pdpInfo = pdp.querySelector('.pdp__info');
  var pdpGallery = pdp.querySelector('.pdp__gallery');

  if (pdpInfo && pdpGallery) {
    var STICK_TOP = 80; // header (68px) + respiro (12px)

    var updateStickyInfo = function () {
      if (window.innerWidth < 990) {
        pdpInfo.classList.remove('is-pinned');
        pdpInfo.style.width = '';
        pdpInfo.style.right = '';
        pdpInfo.style.transform = '';
        return;
      }

      pdpInfo.classList.add('is-pinned');

      // right es relativo al viewport (fixed): el hueco entre el borde
      // real de .pdp y el borde real de la pantalla, mas el propio
      // padding-right de .pdp (getBoundingClientRect da el borde EXTERIOR,
      // fuera del padding, y al ser fixed .pdp__info sale de esa caja por
      // completo, asi que hay que sumarlo a mano).
      var pdpRect = pdp.getBoundingClientRect();
      var pdpPaddingRight = parseFloat(getComputedStyle(pdp).paddingRight) || 0;
      var rightOffset = (window.innerWidth - pdpRect.right) + pdpPaddingRight;
      var galleryRect = pdpGallery.getBoundingClientRect();
      var infoHeight = pdpInfo.offsetHeight;

      pdpInfo.style.width = galleryRect.width + 'px';
      pdpInfo.style.right = rightOffset + 'px';

      // Punto (en Y de viewport) en el que, si siguiera fijo en
      // STICK_TOP, tocaria el final real de las fotos.
      var dockPointY = galleryRect.bottom - infoHeight;

      if (dockPointY < STICK_TOP) {
        // Ya no queda galeria suficiente debajo: en vez de seguir fijo
        // en STICK_TOP, se desplaza hacia arriba justo lo necesario para
        // quedar pegado a ese punto — sigue el scroll de la pagina desde
        // ahi (transform puro, compositor-only, nada de layout nuevo).
        pdpInfo.style.transform = 'translateY(' + (dockPointY - STICK_TOP) + 'px)';
      } else {
        pdpInfo.style.transform = '';
      }
    };

    var tickingStickyInfo = false;
    window.addEventListener(
      'scroll',
      function () {
        if (tickingStickyInfo) return;
        tickingStickyInfo = true;
        requestAnimationFrame(function () {
          updateStickyInfo();
          tickingStickyInfo = false;
        });
      },
      { passive: true }
    );
    window.addEventListener('resize', updateStickyInfo);
    updateStickyInfo();
  }

  // ── Mobile gallery: slider vertical por transform ────────────────────────
  // La galeria no scrollea: es una ventana de una foto y debajo un track que
  // se desplaza con transform, foto a foto (mismo modelo que Swiper, que es
  // lo que usa la referencia de marca). Al no haber un scroller anidado, no
  // hay dos scrolls que coordinar.
  //
  // La clave esta en los bordes: si el gesto empuja mas alla de la primera o
  // la ultima foto, NO se llama a preventDefault. Entonces el navegador se
  // queda el gesto entero y scrollea la pagina el mismo, con su inercia
  // nativa. Esa decision solo puede tomarse en el primer touchmove: despues,
  // el navegador ya ha decidido quien manda en el gesto.
  var mobileGallery = pdp.querySelector('[data-pdp-gallery-mobile]');
  var galleryTrack = pdp.querySelector('[data-pdp-gallery-track]');
  var progressTrack = pdp.querySelector('[data-pdp-gallery-progress]');
  var progressThumb = pdp.querySelector('[data-pdp-gallery-progress-thumb]');

  if (mobileGallery && galleryTrack && galleryTrack.children.length) {
    var slides = galleryTrack.children;
    var lastIndex = slides.length - 1;
    var index = 0;
    var travel = 0;
    var startX = 0;
    var startY = 0;
    var startTime = 0;
    var dragging = false;
    var decided = false;
    var consuming = false;

    // Del propio slide y con decimales: clientHeight redondea a entero, y
    // ese medio pixel por foto se acumula hasta verse como un salto.
    var slideHeight = function () {
      return slides[0].getBoundingClientRect().height;
    };

    var render = function (offset, settling) {
      galleryTrack.classList.toggle('is-settling', !!settling);
      galleryTrack.style.transform =
        'translate3d(0,' + (offset - index * slideHeight()) + 'px,0)';
    };

    var measureProgress = function () {
      if (!progressTrack || !progressThumb) return;
      var trackHeight = progressTrack.clientHeight;
      var thumbHeight = Math.min(trackHeight * 0.5, Math.max(32, trackHeight * 0.16));
      progressThumb.style.height = thumbHeight + 'px';
      travel = trackHeight - thumbHeight;
    };

    var updateProgress = function () {
      if (!progressTrack || !progressThumb) return;
      progressThumb.style.transform =
        'translateY(' + (lastIndex > 0 ? index / lastIndex : 0) * travel + 'px)';
    };

    var goTo = function (next) {
      index = Math.min(lastIndex, Math.max(0, next));
      render(0, true);
      updateProgress();
    };

    mobileGallery.addEventListener('touchstart', function (e) {
      if (lastIndex < 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTime = e.timeStamp;
      dragging = true;
      decided = false;
      consuming = false;
      // Avisa al navegador justo antes de mover, no de forma permanente.
      galleryTrack.classList.add('is-dragging');
    }, { passive: true });

    mobileGallery.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (!decided) {
        // Hasta que el gesto no tiene una direccion clara no se decide nada:
        // hacerlo con el primer pixel confunde el temblor del dedo con una
        // direccion real.
        if (Math.abs(dx) + Math.abs(dy) < 8) return;
        decided = true;
        // dy > 0 = el dedo baja = foto anterior.
        var pastStart = dy > 0 && index === 0;
        var pastEnd = dy < 0 && index === lastIndex;
        consuming = Math.abs(dy) > Math.abs(dx) && !pastStart && !pastEnd;
      }

      if (!consuming) return;
      e.preventDefault();
      render(dy, false);
    }, { passive: false });

    var endTouch = function (e) {
      if (!dragging) return;
      dragging = false;
      galleryTrack.classList.remove('is-dragging');
      if (!consuming) return;
      var dy = e.changedTouches[0].clientY - startY;
      // Con un umbral corto basta un gesto normal para pasar de foto, sin
      // tener que arrastrar media pantalla. Un flick rapido (poco recorrido
      // pero mucha velocidad) tambien cambia de foto, como un swipe normal.
      var elapsed = Math.max(1, e.timeStamp - startTime);
      var velocity = Math.abs(dy) / elapsed;
      var isFlick = velocity > 0.5 && Math.abs(dy) > 12;
      var threshold = Math.min(35, slideHeight() * 0.05);
      if (dy <= -threshold || (dy < 0 && isFlick)) goTo(index + 1);
      else if (dy >= threshold || (dy > 0 && isFlick)) goTo(index - 1);
      else goTo(index);
    };

    mobileGallery.addEventListener('touchend', endTouch);
    mobileGallery.addEventListener('touchcancel', endTouch);

    // Terminada la animacion se suelta la capa de composicion: si no,
    // is-settling se queda puesto y el will-change vuelve a ser permanente.
    galleryTrack.addEventListener('transitionend', function (e) {
      if (e.target === galleryTrack) galleryTrack.classList.remove('is-settling');
    });

    window.addEventListener('resize', function () {
      measureProgress();
      render(0, false);
      updateProgress();
    });

    measureProgress();
    render(0, false);
    updateProgress();

    // Arrastrar la pastilla (o tocar en cualquier punto de la pista) para
    // navegar la galeria directamente, en vez de solo poder leer el
    // progreso.
    if (progressTrack && progressThumb) {
      var isDragging = false;

      var pctFromPointer = function (clientY) {
        var trackRect = progressTrack.getBoundingClientRect();
        var thumbHeight = progressThumb.offsetHeight;
        var relY = clientY - trackRect.top - thumbHeight / 2;
        return Math.min(1, Math.max(0, relY / (trackRect.height - thumbHeight)));
      };

      // Mientras se arrastra la pastilla, la foto sigue el dedo de forma
      // continua (sin redondear a un indice ni transicion) — igual que el
      // swipe sobre la propia foto. Solo al soltar se "asienta" en la foto
      // mas cercana (goTo, con su transicion de settle).
      var dragTo = function (pct) {
        var fracIndex = pct * lastIndex;
        galleryTrack.classList.remove('is-settling');
        galleryTrack.style.transform = 'translate3d(0,' + (-fracIndex * slideHeight()) + 'px,0)';
        progressThumb.style.transform = 'translateY(' + pct * travel + 'px)';
      };

      var startDrag = function (e) {
        isDragging = true;
        progressTrack.classList.add('is-dragging');
        progressTrack.setPointerCapture(e.pointerId);
        dragTo(pctFromPointer(e.clientY));
        e.preventDefault();
      };

      var moveDrag = function (e) {
        if (!isDragging) return;
        dragTo(pctFromPointer(e.clientY));
      };

      var endDrag = function (e) {
        if (!isDragging) return;
        isDragging = false;
        progressTrack.classList.remove('is-dragging');
        goTo(Math.round(pctFromPointer(e.clientY) * lastIndex));
      };

      progressTrack.addEventListener('pointerdown', startDrag);
      progressTrack.addEventListener('pointermove', moveDrag);
      progressTrack.addEventListener('pointerup', endDrag);
      progressTrack.addEventListener('pointercancel', endDrag);
    }
  }

  // ── Tabs de información ─────────────────────────────────────────────────
  // Una sola visible a la vez y siempre una abierta: al contrario que el
  // acordeon, aqui la ficha nunca se queda sin informacion a la vista.
  var tabsRoot = pdp.querySelector('[data-pdp-tabs]');
  if (tabsRoot) {
    var tabs = tabsRoot.querySelectorAll('[data-pdp-tab]');
    var panels = tabsRoot.querySelectorAll('[data-pdp-tab-panel]');

    // "See more" solo donde el texto desborda de verdad: en una pestaña de
    // dos lineas el boton sobra. Se mide con el recorte puesto, comparando
    // el alto real del contenido con el visible.
    panels.forEach(function (panel) {
      var content = panel.querySelector('[data-pdp-tab-content]');
      var more = panel.querySelector('[data-pdp-tab-more]');
      if (!content || !more) return;
      content.classList.add('is-clamped');
      // Un panel oculto mide 0, asi que se destapa un instante para medir.
      var wasHidden = panel.hidden;
      panel.hidden = false;
      var overflows = content.scrollHeight - content.clientHeight > 4;
      panel.hidden = wasHidden;
      if (!overflows) {
        content.classList.remove('is-clamped');
        return;
      }
      more.hidden = false;
      more.addEventListener('click', function () {
        var clamped = content.classList.toggle('is-clamped');
        more.textContent = clamped
          ? more.dataset.labelMore || 'See more'
          : more.dataset.labelLess || 'See less';
      });
    });

    // Flechas de desbordamiento: solo aparecen si queda barra por recorrer
    // en ese lado, y desplazan poco menos de un ancho visible para que el
    // titulo del borde no se salte de golpe.
    var bar = tabsRoot.querySelector('[data-pdp-tabs-bar]');
    var prev = tabsRoot.querySelector('[data-pdp-tabs-prev]');
    var next = tabsRoot.querySelector('[data-pdp-tabs-next]');
    if (bar && prev && next) {
      var syncNav = function () {
        var max = bar.scrollWidth - bar.clientWidth;
        prev.hidden = bar.scrollLeft <= 1;
        next.hidden = bar.scrollLeft >= max - 1;
      };
      var nudge = function (dir) {
        bar.scrollBy({ left: dir * bar.clientWidth * 0.8, behavior: 'smooth' });
      };
      prev.addEventListener('click', function () { nudge(-1); });
      next.addEventListener('click', function () { nudge(1); });
      bar.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.pdpTab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.hidden = p.dataset.pdpTabPanel !== key;
        });
      });
    });
  }

  // ── Size guide modal ─────────────────────────────────────────────────────
  var sizeGuideOpenBtns = pdp.querySelectorAll('[data-size-guide-open]');
  var sizeGuideModal = document.querySelector('[data-size-guide-modal]');

  if (sizeGuideOpenBtns.length && sizeGuideModal) {
    sizeGuideOpenBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeGuideModal.hidden = false;
      });
    });
    sizeGuideModal.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeGuideModal.hidden = true;
      });
    });
  }

})();
